export var environment = {
  production: true,
  id: "com.gozmartch.gzre",
  BASE_URL: "PROD",
  css: "emiZmart",
  version: "v1.3.66 - 02.11.2020",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts